module.exports = __webpack_public_path__ + "img/light-switch-md.e5cfb67f.svg";